import React from 'react';
import tpl from '../templates/atb-new';
import BaseNewCardView from '../../views/BaseNewCardView';
import {apiback} from '../../../../config';
import CreditCardsModel from '../../models/creditCards.m';
import {canUseDOM} from '../../../../helpers/canUseDOM';

export default class extends BaseNewCardView {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            ui: this.uiStates.INITIAL,
            model: {},
            tab: 'tariffs'
        };
    }

    componentWillMount() {
        super.componentWillMount();
        if (!canUseDOM) return;
        fetch(apiback('CREDIT_CARDS'))
            .then(res => res.json())
            .then(json =>
                this.setState({
                    model: new CreditCardsModel(json.data['atb_card'])
                })
            );
    }

    static displayName = 'ATBCard.Views.Main';
}
